import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faBell } from '@fortawesome/free-solid-svg-icons';

/**
 * A notification from an outside application, in that app's chat with you
 * (server: routes/integrations.js). Laid out like the task cards, on the
 * incoming side.
 *
 * The link was checked against the app's own domains before it was stored,
 * and it opens in a new tab with no opener, so the app's page cannot reach
 * back into the portal.
 */

const clockTime = (iso) =>
    new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

const AppNotificationCard = ({ id, message }) => {
    const app = message.systemEvent?.app || {};

    return (
        <div id={id} className="msgr-msg in first-of-run">
            <div className="msgr-bubble msgr-approval msgr-appnote">
                {app.title && (
                    <div className="msgr-approval-head">
                        <FontAwesomeIcon icon={faBell} />
                        <span><strong>{app.title}</strong></span>
                    </div>
                )}

                <div className="msgr-appnote-text">{message.text}</div>

                {app.link && (
                    <div className="msgr-approval-actions">
                        <a
                            className="msgr-appnote-link"
                            href={app.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {app.linkLabel || 'Open'} <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </a>
                    </div>
                )}

                {message.createdAt && <div className="msgr-approval-time">{clockTime(message.createdAt)}</div>}
            </div>
        </div>
    );
};

export default AppNotificationCard;
